<template>
	<div>
		<div class="mb-3 d-flex align-items-center">
			<small>Columns</small>
			<div class="ml-auto small d-flex align-items-center">
				<template v-if="canSelectAll">
					<a @click.prevent="selectAllOptions()" class="px-1" href
						>Select All</a
					>
					<span>|</span>
				</template>
				<template v-if="searchQuery">
					<a @click.prevent="resetColumns" class="px-1" href
						>View All Columns</a
					>
					<span>|</span>
				</template>
				<a
					@click.prevent="filterDefaults = !filterDefaults"
					:class="{ 'font-weight-bold': filterDefaults }"
					class="px-1"
					href
					>Default</a
				>

				<template v-if="!canSelectAll">
					<span>|</span>
					<a @click.prevent="clearSelection" class="px-1" href
						>Clear</a
					>
				</template>
			</div>
			<div class="ml-2">
				<b-input
					v-model="searchQuery"
					size="sm"
					placeholder="Search column"
				></b-input>
			</div>
		</div>
		<b-form-checkbox-group
			v-if="columnsOptions.length"
			v-model="innerValue"
			@change="onChange"
			:options="columnsOptions"
			class="checkbox-group d-flex align-items-start flex-wrap"
			stacked
		></b-form-checkbox-group>
		<p v-else class="m-0 small">No items found.</p>
	</div>
</template>

<script>
import Fuse from "fuse.js";

import { default as columns } from "@components/SaveReportWizard/utils/exportColumns";

export default {
	props: ["value"],
	data() {
		return {
			searchQuery: null,
			filterDefaults: false,
			innerValue: [],
		};
	},
	computed: {
		canSelectAll() {
			return this.innerValue.length < this.columnsOptions.length;
		},
		columnsOptions() {
			let results = columns;
			const fuse = new Fuse(results, {
				keys: ["text"],
				useExtendedSearch: true,
			});

			if (this.filterDefaults)
				results = results.filter((item) => item.default);

			if (this.searchQuery)
				results = fuse.search(`'${this.searchQuery}`).map((item) => ({
					text: item.item.text,
					value: item.item.value,
				}));

			return results;
		},
	},
	methods: {
		onChange(value) {
			this.$emit("input", value);
		},
		selectAllOptions() {
			const allOptions = columns.map((item) => item.value);

			this.filterDefaults = false;
			this.innerValue = allOptions;

			this.$emit("input", allOptions);
		},
		clearSelection() {
			this.filterDefaults = false;
			this.innerValue = [];

			this.$emit("input", []);
		},
		resetColumns() {
			this.searchQuery = null;
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				if (!newVal.length && !oldVal) this.selectAllOptions();
				else this.innerValue = newVal;
			},
		},
		filterDefaults(newVal) {
			if (!newVal) return false;

			this.innerValue = columns
				.filter((item) => item.default)
				.map((item) => item.value);
		},
	},
};
</script>

<style lang="scss">
.checkbox-group {
	width: 100%;
	max-height: 325px;
	overflow-y: auto;

	.custom-control {
		width: 25%;
		margin-bottom: 5px;

		&-label {
			span {
				font-size: 14px;
				line-height: 1.2;
				display: block;
			}
		}
	}
}
</style>
